import fontawesome from '@fortawesome/fontawesome'
import faInstagram from '@fortawesome/fontawesome-free-brands/faInstagram'
// import faStar from '@fortawesome/fontawesome-free-regular/faStar'
// import faTrash from '@fortawesome/fontawesome-free-solid/faTrash'
import faUser from '@fortawesome/fontawesome-free-solid/faUser'
import faKey from '@fortawesome/fontawesome-free-solid/faKey'
import faMobileAlt from '@fortawesome/fontawesome-free-solid/faMobileAlt'
import faHandshake from '@fortawesome/fontawesome-free-solid/faHandshake'
import faCreditCard from '@fortawesome/fontawesome-free-solid/faCreditCard'
import faFile from '@fortawesome/fontawesome-free-solid/faFile'
import faBars from '@fortawesome/fontawesome-free-solid/faBars'
import faAngleDown from '@fortawesome/fontawesome-free-solid/faAngleDown'
import faTachometerAlt from '@fortawesome/fontawesome-free-solid/faTachometerAlt'
import faBell from '@fortawesome/fontawesome-free-solid/faBell'
import faEnvelope from '@fortawesome/fontawesome-free-solid/faEnvelope'
import faChartLine from '@fortawesome/fontawesome-free-solid/faChartLine'
import faMoneyBill from '@fortawesome/fontawesome-free-solid/faMoneyBill'
import faChartPie from '@fortawesome/fontawesome-free-solid/faChartPie'
import faChartBar from '@fortawesome/fontawesome-free-solid/faChartBar'
import faClock from '@fortawesome/fontawesome-free-solid/faClock'
import faWrench from '@fortawesome/fontawesome-free-solid/faWrench'
import faThLarge from '@fortawesome/fontawesome-free-solid/faThLarge'
import faColumns from '@fortawesome/fontawesome-free-solid/faColumns'
import faPencilAlt from '@fortawesome/fontawesome-free-solid/faPencilAlt'
import faTimes from '@fortawesome/fontawesome-free-solid/faTimes'
import faInfoCircle from '@fortawesome/fontawesome-free-solid/faInfoCircle'
import faSort from '@fortawesome/fontawesome-free-solid/faSort'
import faSearch from '@fortawesome/fontawesome-free-solid/faSearch'
import faQuestion from '@fortawesome/fontawesome-free-solid/faQuestion'
import faPlus from '@fortawesome/fontawesome-free-solid/faPlus'
import faLightbulb from '@fortawesome/fontawesome-free-solid/faLightbulb'
import faInfo from '@fortawesome/fontawesome-free-solid/faInfo'
import faClipboardList from '@fortawesome/fontawesome-free-solid/faClipboardList'
import faEye from '@fortawesome/fontawesome-free-solid/faEye'
import faServer from '@fortawesome/fontawesome-free-solid/faServer'
import faAddressCard from '@fortawesome/fontawesome-free-solid/faAddressCard'
import faProjectDiagram from '@fortawesome/fontawesome-free-solid/faProjectDiagram'
import faShoppingCart from '@fortawesome/fontawesome-free-solid/faShoppingCart'
import faCube from '@fortawesome/fontawesome-free-solid/faCube'


import faBuilding from '@fortawesome/fontawesome-free-solid/faBuilding'


fontawesome.library.add(
    faKey,faUser,faMobileAlt,faHandshake,faCreditCard,faFile,faBars,faAngleDown,faTachometerAlt,faBell,
    faEnvelope,faChartLine,faMoneyBill,faChartBar,faChartPie,faClock,faWrench,faThLarge,faColumns,
    faPencilAlt,faTimes,faInfoCircle,faSort,faSearch,faQuestion,faPlus,faLightbulb,faInfo,faEye,
    faClipboardList,faServer,faAddressCard,faProjectDiagram,faShoppingCart,faCube,

    faBuilding
)

